<template>
  <div class="introduce">
    <div class="content">
      <div class="img" v-show="isLeft">
        <img :src=img alt="">
      </div>
      <div class="desc">
        <div>
          <div class="strong">{{title}}</div>
          <div style="text-indent: 2em;">{{text}}</div>
        </div>
       <div>
         <div class="strong" style="margin-top: 16px">{{titleEnglish}}</div>
         <div style="text-indent: 2em;">{{english}}</div>
       </div>
      </div>
      <div class="img" v-show="!isLeft">
        <img :src=img alt="">
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Introduce",
    props:{
      title:{
        type:String
      },
      text:{
        type:String
      },
      titleEnglish: {
        type: String
      },
      english: {
        type: String
      },
      isLeft:{
        type:Boolean,
        default() {
          return true
        }
      },
      isWhite:{
        type: Boolean,
        default(){
          return false
        }
      },
      img:{
        type:String
      }
    },
  }
</script>

<style lang="less" scoped>
  .bgc{
    background-color: #FAFAFA;
  }
  .introduce{
    display: flex;
    height: 500px;
    width: 100%;
    .content{
      width: 100%;
      height: 100%;
      display: flex;
      padding: 0 0 0 60px;
      align-items: center;
      //border: 1px solid red;
      font-size: 16px;
      line-height: 30px;
      color: #000000;
      img{
        height: 400px;
        width: 550px;
        margin-left: 16px;
      }
      .desc {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: calc(100% - 100px);
        width: calc(100% - 90px - 50px);
        overflow: auto;
        padding-right: 30px;
        .strong{
          margin-bottom: 20px;
          font-size: 25px;
          font-weight: bold;
        }
        .text{
          margin-right: 50px;
        }

        &::-webkit-scrollbar {
          width: 8px;
        }
        &::-webkit-scrollbar-track {
          background-color: none;
        }
        &::-webkit-scrollbar-thumb {
          background-color: #d3dce6;
          border-radius: 10px;
        }
      }
      .img{
        margin-right: 50px;
      }
    }
  }
</style>
